__turbopack_context__.v({
  "action": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__action",
  "body": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__body",
  "card": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__card",
  "copy": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__copy",
  "cta": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__cta",
  "eyebrow": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__eyebrow",
  "heading": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__heading",
  "icon": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__icon",
  "illustration": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__illustration",
  "message": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__message",
  "root": "CreatorAcquisitionPrompt-module-scss-module__lYnA8a__root",
});
